import {
  addConnectedUser,
  deleteConnectedUser,
  selectUserById,
  setAllUsers,
  setOnlineUsers as setOnlineUsersState,
  setSocketConnection as setSocketConnectionState,
  updateConnectedUser,
} from "@/store/reducers/user";
import useJwt from "@/utils/jwt/useJwt";

// ** Get all User
export const getAllUsers = () => {
  return async (dispatch) => {
    useJwt
      .getAllUsers()
      .then((res) => {
        if (res.data.ResponseCode === 0) {
          const data = res.data.ResponseResult;
          dispatch(setAllUsers(data));
        } else {
          console.log(res.data.ResponseCode);
        }
      })
      .catch((err) => console.log(err));
  };
};

// ** Get User
export const getUser = (id) => selectUserById(id);

// ** Add new user
export const addUser = (user) => addConnectedUser(user);

export const updateUser = (user) => updateConnectedUser(user);

// ** Delete user
export const deleteUser = (id) => deleteConnectedUser(id);

// ** set On line Users
export const setOnlineUsers = (data) => setOnlineUsersState(data);

export const setSocketConnection = (data) => setSocketConnectionState(data);
